import { createSlotRecipe } from './runtime';

const comboboxConfig = {"name":"combobox","slots":["root","clearTrigger","content","control","input","item","itemGroup","itemGroupLabel","itemIndicator","itemText","label","list","positioner","trigger"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const combobox = /* @__PURE__ */ createSlotRecipe(comboboxConfig)